var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvalidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 44 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Invalidate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sample---Invalidate",
    transform: "translate(-270.000000, -38.000000)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(40.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialogs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Area"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invalidate",
    transform: "translate(208.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4187234,31.5733333 L27.8876596,16.4266667",
    id: "Shape",
    stroke: "#00B5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    stroke: "#002C8B",
    x: 0.544680851,
    y: 0.533333333,
    width: 39.2170213,
    height: 46.9333333
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00B5E1",
    cx: 20.1531915,
    cy: 24,
    rx: 10.893617,
    ry: 10.6666667
  }))))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidate);
export default __webpack_public_path__ + "static/media/Invalidate.bef65a0f.svg";
export { ForwardRef as ReactComponent };